<template>
  <div>
    <!-- Email -->
    <text-input
      id="contact-email"
      name="Email"
      rules="required|email"
      :text.sync="contact.email"
    />

    <!-- Country Select -->
    <country-select
      :items.sync="contact.country"
      rules="required"
    />

    <!-- First Name -->
    <text-input
      id="contact-first-name"
      name="First Name"
      rules="required|min:3|max:250"
      :text.sync="contact.first_name"
    />

    <!-- Last Name -->
    <text-input
      id="contact-last-name"
      name="Last Name"
      rules="required|min:3|max:250"
      :text.sync="contact.last_name"
    />

    <!-- Company Name -->
    <text-input
      id="contact-company"
      name="Company Name"
      rules="required|min:3|max:250"
      :text.sync="contact.company"
    />

    <!-- Phone -->
    <text-input
      id="contact-phone"
      name="Phone Number"
      rules="required|min:7"
      type="number"
      :text.sync="contact.phone"
    />

    <!-- Tickets Sold In A Year -->
    <custom-vue-select
      id="tickets-sold-count"
      label="How many tickets do you sell in one year?"
      placeholder="Tickets Count"
      rules="required"
      :value-reducer="option=>option.value"
      :text-field="option=>option.text"
      :options="[
        {text:'I only host a free events',value:'ONE'},
        {text:'1-250',value:'TWO'},
        {text:'250-500',value:'THREE'},
        {text:'500-1000',value:'FOUR'},
        {text:'1000-5000',value:'FIVE'},
        {text:'5000-10000',value:'SIX'},
        {text:'I don\'t host events:',value:'SEVEN'},
      ]"
      :selected.sync="contact.number_tickets"
    />

    <!-- Reason for getting in touch -->
    <custom-vue-select
      id="contact-reason"
      label="Reason for getting in touch"
      rules="required"
      :text-field="option=>option.text"
      :value-reducer="option=>option.value"
      :options="[
        {text:'I want to know how to use Do event to manage my events',value:'ONE'},
        {text:'I am already a customer looking for help with my account',value:'TWO'},
        {text:'I have a Question about ticket I purchased for an event',value:'THREE'},
        {text:'Something else',value:'FOUR'}
      ]"
      :selected.sync="contact.touch"
    />

    <!-- How did you hear about do events -->
    <text-area-input
      id="contact-how"
      rules="required"
      name="How did you hear about DoEvents?"
      :text.sync="contact.hear"
    />
  </div>
</template>

<script>
import TextInput from '@/components/FormInputs/TextInput.vue'
import CustomVueSelect from '@/components/FormInputs/CustomVueSelect.vue'
import TextAreaInput from '@/components/FormInputs/TextAreaInput.vue'
import CountrySelect from '@/components/GeneralSettings/Countries/CountrySelect.vue'

export default {
  name: 'ContactSalesInputs',
  components: {
    TextInput, CustomVueSelect, TextAreaInput, CountrySelect,
  },
  props: {
    contact: { type: Object, default: () => {} },
  },
}
</script>

<style>

</style>
